/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ChangeDetectorRef, Component, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Select, Store } from '@ngxs/store';
import { ReCaptchaV3Service, RecaptchaComponent } from 'ng-recaptcha-2';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { RedirectHelper } from '../../../page-modules/resource/store/editor/content/helpers/redirect.helper';
import { SnackbarHelper } from '../../../shared/helpers/snackbar-helper';
import { Organization } from '../../../shared/models';
import { MaintenanceService } from '../../../shared/services/maintenance/maintenance.service';
import { AUTH_SERVICE, BasicAuthService } from '../../services/basic-auth.service';
import { UserAuthState } from '../../store/user-auth.state';

@Component({
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
})
export class VerifyEmailComponent implements OnInit {
  @Select(UserAuthState.organizationDetails)
  organizationData$: Observable<Organization>;

  @ViewChild('captchaElem', { static: false }) captchaElem: RecaptchaComponent;

  isLoading: boolean;
  email: string;
  reCaptchaSiteKeyV2 = environment.reCaptchaSiteKeyV2;
  showMaintenanceOverlay: boolean;

  constructor(
    private store: Store,
    private activatedRoute: ActivatedRoute,
    @Inject(AUTH_SERVICE) private authService: BasicAuthService,
    private router: Router,
    private snackBar: MatSnackBar,
    private ngZone: NgZone,
    private translocoService: TranslocoService,
    private cdr: ChangeDetectorRef,
    private captchaV3Service: ReCaptchaV3Service,
    private maintenanceService: MaintenanceService,
  ) {
    this.showMaintenanceOverlay = this.maintenanceService.showMaintenanceMessage();
  }

  ngOnInit() {
    this.email = this.activatedRoute.snapshot.queryParamMap.get('email');
  }

  resendEmailVerification() {
    if (this.email) {
      this.captchaElem.execute();
    }
  }

  proceedIfValid(captchaResponseV2: string | null) {
    if (!captchaResponseV2) return;
    this.proceedResend(captchaResponseV2);
  }

  private proceedResend(captchaResponseV2: string) {
    this.isLoading = true;
    const organizationUid = this.store.selectSnapshot(UserAuthState.organizationDetails)._id;
    const email = this.email;
    this.captchaV3Service.execute('verifyFolioEmail').subscribe((captchaResponseV3: string) => {
      this.authService
        .resendVerificationEmail(email, organizationUid, captchaResponseV3, captchaResponseV2)
        .subscribe(({ isSuccess, error }) => {
          this.isLoading = false;
          if (isSuccess) {
            RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, '/signin');
            SnackbarHelper.showTranslatableSnackBar(this.ngZone, this.snackBar, this.translocoService, 'translations.verifyYourAccount');
          } else {
            SnackbarHelper.showSnackBar(this.ngZone, this.snackBar, error);
          }
          this.captchaElem.reset();
          this.cdr.detectChanges();
        });
    });
  }
}
